import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import Parking from '../components/parking/Parking';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import CreateParking from '../components/parking/CreateParking';
import Stalls from '../components/parking/Stalls';
import MyStalls from '../components/parking/MyStalls';
import MyStallsDetails from '../components/parking/MyStallsDetails';
import EditParking from '../components/parking/EditParking';

const ParkingRoutes = ({ match: { url } }) =>
  <Switch>
    <ProtectedRoute exact path={`${url}`} rols={['manager','safety']} component={Parking} />
    <ProtectedRoute exact path={`${url}/:id(\\d+)/stalls`} rols={['manager','safety']} component={Stalls} />
    <ProtectedRoute exact path={`${url}/stalls/:id(\\d+)`} rols={['safety']} component={MyStallsDetails} />
    
    <ProtectedRoute exact path={`${url}/my/stalls`} rols={['property']} component={MyStalls} />
    <ProtectedRoute exact path={`${url}/my/stalls/:id(\\d+)`} rols={['property','safety']} component={MyStallsDetails} />
    
    <ProtectedRoute exact path={`${url}/create`} rols={['manager']} component={CreateParking} />
    <ProtectedRoute exact path={`${url}/:id(\\d+)/edit`} rols={['manager']} component={EditParking} />
    <Redirect to="/errors/404" />
  </Switch>

ParkingRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(ParkingRoutes);